import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Pagination from "react-bootstrap/Pagination";

const PendingBalance = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3); // Change the items quantity of pegination
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {

      // Initial fetch
      getData(token);

      const interval = setInterval(() => {
        getData(token);
      }, 10000); // every 10 seconds

      return () => clearInterval(interval);
    }
  }, [token, navigate]);

  const getData = async (token) => {
    setLoading(true);
    try {
      let response = await getOrder(token);

      let fetchedOrders = [];

      if (Array.isArray(response)) {
        fetchedOrders = response;
      } else if (
        response?.status === "success" &&
        Array.isArray(response?.myOrders)
      ) {
        fetchedOrders = response.myOrders;
      }

      setOrders(fetchedOrders);
    } catch (error) {
      console.error("Error fetching data:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(orders.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const ordersShow = orders.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const renderPaginationItems = () => {
    const items = [];

    items.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => handlePageClick(1)}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let page = currentPage - 1; page <= currentPage + 1; page++) {
      if (page > 1 && page < totalPages) {
        items.push(
          <Pagination.Item
            key={page}
            active={currentPage === page}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </Pagination.Item>
        );
      }
    }

    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          />
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <h5>Pending commissions</h5>
              {orders.length > 0 ? (
                <h6 className="text-muted">View Pending Commissions</h6>
              ) : loading ? (
                <h6 className="text-muted">Loading...</h6>
              ) : (
                <h6 className="text-muted">No Pending Commissions</h6>
              )}
            </div>

            <div className="col-12 mt-5">
              {
                ordersShow.length > 0
                  ?
                  <div className="row">
                    {
                      ordersShow.map((order, i) => {
                        const orderDate = new Date(order.createdAt);
                        const creditedDate = new Date(orderDate);
                        creditedDate.setDate(orderDate.getDate() + 7);

                        const formattedOrderDate =
                          orderDate.toLocaleDateString("en-IN") +
                          " " +
                          orderDate.toLocaleTimeString("en-IN", {
                            hour12: false,
                          });

                        const formattedCreditedDate =
                          creditedDate.toLocaleDateString("en-IN") +
                          " " +
                          creditedDate.toLocaleTimeString("en-IN", {
                            hour12: false,
                          });

                        return (
                          <div className="col-12 mb-4">
                            <div className="bg-white shadow rounded p-3">
                              <div className="row mb-4">
                                <div className="col-10">
                                  <h4 className="h5 fw-semibold text-dark mb-2">
                                    Order ID: <span className="text-primary">#{order.orderNumber}</span>
                                  </h4>
                                  <p className="mb-1 text-muted small">
                                    Ordered On: <span className="fw-medium">{formattedOrderDate}</span>
                                  </p>
                                  {/* <p className="text-muted small">
                                    Credited On: <span className="fw-medium">{formattedCreditedDate}</span>
                                  </p> */}
                                  <p className="text-muted small fw-bold mt-3">
                                    Total commission:
                                    <span className="fw-medium">
                                      <Icon.CurrencyRupee />
                                      {order.commission_amount === null ||
                                        order.commission_amount === 0
                                        ? "0.00"
                                        : Number(order.commission_amount).toFixed(2)}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-2 text-end">
                                  <Link
                                    to={`/pending-balance/${order.orderNumber}`}
                                    className="btn btn-outline-dark"
                                  >
                                    <Icon.ArrowRight />
                                  </Link>
                                </div>
                              </div>

                              <div className="table-responsive">
                                <table className="table table-sm table-bordered">
                                  <thead className="table-light text-center">
                                    <tr>
                                      <th>Product ID</th>
                                      <th>Title</th>
                                      <th>Quant</th>
                                      <th>Commission Amount</th>
                                      <th>Cradit Amount</th>
                                      <th>Status</th>
                                      <th>Commission Processed</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {order.products.map((product, index) => (
                                      <tr key={index}>
                                        <td>{product.id}</td>
                                        <td style={{ fontSize: "12px" }}>{product.title}</td>
                                        <td>{product.quantity}</td>
                                        <td>₹{product.commissionAmount}</td>
                                        <td>₹{product.commissionAmount * product.quantity}</td>
                                        <td className={`fw-medium text-${product.statusColor}`}>
                                          {product.orderStatus}
                                        </td>
                                        <td>
                                          <span
                                            className={`badge bg-${product.commissionProssed ? 'success text-light' : 'warning text-dark'}`}
                                          >
                                            {product.commissionProssed ? 'Yes' : 'No'}
                                          </span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                  :
                  (
                    <div className="container-fluid bg-light text-center p-5">
                      No Pending Commissions
                    </div>
                  )
              }
            </div>

            {/* Pagination controls */}
            {
              ordersShow.length > 0 &&
              <div className="d-flex justify-content-center mt-4">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageClick(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  />
                  {renderPaginationItems()}
                  <Pagination.Next
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageClick(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingBalance;

// API Function
export const getOrder = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}order/getallorders`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
